import { j as e } from "../../jsx-runtime-Wav_3Wde.js";
import m from "../../Logo/CapitalOne/assets/CapitalOneLogoBHM.mjs";
import "../../Logo/CapitalOne/Loadable.mjs";
import "../../Logo/StyledPath.mjs";
import p from "../../Logo/CapitalOne/assets/CapitalOneLogoCoreDark.mjs";
import c from "../../Logo/CapitalOne/assets/CapitalOneLogoPride.mjs";
import "../../Logo/PostOffice/Loadable.mjs";
import "styled-components";
import "../../Logo/PostOffice/LogoTemplate.mjs";
import "../../Logo/PostOffice/LoadableCore.mjs";
import "../../Logo/Luma/Loadable.mjs";
import "../../Logo/Very/Loadable.mjs";
import "../../Logo/Littlewoods/Loadable.mjs";
import "../../Logo/Ocean/Loadable.mjs";
import "../../Logo/ThinkMoney/Loadable.mjs";
import "../../Logo/ASOS/Loadable.mjs";
import "../../Logo/DirectDebit/Loadable.mjs";
import "../../Logo/BaseLogo.mjs";
import { useBrand as g } from "../../providers/BrandProvider/brandProvider.mjs";
import { defaultBrandConfig as d } from "../BrandedLogo/BrandedLogo.mjs";
import { C as i, a as f } from "../../brands-CoixlYYY.js";
const C = ({ variant: o, ...r }) => {
  const t = (/* @__PURE__ */ new Date()).getMonth() + 1, a = (/* @__PURE__ */ new Date()).getDate();
  switch (!0) {
    case t === 6:
    case t === 7:
    case (t === 8 && a <= 7):
      return /* @__PURE__ */ e.jsx(c, {
        flexShrink: 0,
        logoProps: {
          secondaryColor: o === "light" ? "global.white" : "capitalOne.blue750",
          label: `Capital One logo Pride month ${o} variant`
        },
        ...r
      });
    case t === 10:
    case (t === 11 && a <= 7):
      return /* @__PURE__ */ e.jsx(m, {
        flexShrink: 0,
        logoProps: {
          secondaryColor: o === "light" ? "global.white" : "global.black",
          label: `Capital One logo Black History month ${o} variant`
        },
        ...r
      });
    default:
      return /* @__PURE__ */ e.jsx(p, {
        flexShrink: 0,
        logoProps: {
          secondaryColor: o === "light" ? "global.white" : "capitalOne.blue750",
          label: `Capital One logo ${o} variant`
        },
        ...r
      });
  }
}, l = {
  ...d,
  [i]: C
}, R = ({ allowList: o = f, brandConfig: r = l, variant: t = "dark", ...a }) => {
  const n = g(o), s = r[n] || l[i];
  return /* @__PURE__ */ e.jsx(s, {
    variant: t,
    ...a
  });
};
export {
  R as default,
  l as defaultSeasonalBrandConfig
};
